import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useStore } from "@/lib/useStore";
import { ArrowRight } from "lucide-react";

/**
 * Netflix-style email capture row.
 *  - Submitting navigates to /s/{slug}/signup?email=...&intent=subscribe
 *  - The signup page reads ?email= and pre-fills the email input.
 */
export default function EmailCapture({
  tenantSlug,
  accentColor = "#F59E0B",
  themeColor = "#7C3AED",
  buttonLabel = "Get Started",
  testid = "email-capture",
}) {
  const navigate = useNavigate();
  const { sp } = useStore();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const v = email.trim();
    if (!v || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) {
      setError("Please enter a valid email");
      return;
    }
    setError("");
    const q = new URLSearchParams({ email: v, intent: "subscribe" }).toString();
    navigate(sp(`/signup?${q}`));
  };

  return (
    <form onSubmit={submit} className="w-full max-w-2xl" data-testid={testid}>
      <div className="flex flex-col md:flex-row gap-3" data-testid={`${testid}-row`}>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => { setEmail(e.target.value); if (error) setError(""); }}
          placeholder="Email address"
          className="flex-1 h-14 md:h-16 bg-black/55 border border-white/25 px-5 text-base text-white placeholder:text-white/45 focus:outline-none focus:border-white transition-colors"
          data-testid={`${testid}-input`}
          aria-label="Email address"
        />
        <button
          type="submit"
          className="h-14 md:h-16 px-6 md:px-8 inline-flex items-center justify-center gap-2 text-sm md:text-base font-bold uppercase tracking-[0.18em] transition-transform hover:-translate-y-0.5 active:translate-y-0 whitespace-nowrap"
          style={{ backgroundColor: accentColor, color: "#0a0a0a" }}
          data-testid={`${testid}-submit`}
        >
          {buttonLabel} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
      {error && (
        <div className="mt-2 text-xs text-rose-300" data-testid={`${testid}-error`}>{error}</div>
      )}
    </form>
  );
}
